import { render, staticRenderFns } from "./GraficoSortimento.vue?vue&type=template&id=5c58d0e6"
import script from "./GraficoSortimento.vue?vue&type=script&lang=js"
export * from "./GraficoSortimento.vue?vue&type=script&lang=js"
import style0 from "./GraficoSortimento.vue?vue&type=style&index=0&id=5c58d0e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports